export enum ComponentTypeValues {
  Search = 'Search',
  Select = 'Select',
  DatePicker = 'DatePicker'
}